import React from 'react'
import { createContext, useContext } from 'react'
import { ILearningResourceCategory } from 'marketing-site/@types/generated/contentful'

export interface ILearnDirectoryContext {
  categories: ILearningResourceCategory[]
}

const LearnDirectoryContext = createContext<ILearnDirectoryContext>({
  categories: [],
})

LearnDirectoryContext.displayName = 'LearnDirectoryContext'

export const LearnDirectoryContextProvider: React.FC<ILearnDirectoryContext> = ({
  children,
  ...props
}) => <LearnDirectoryContext.Provider value={props}>{children}</LearnDirectoryContext.Provider>

export const useLearnDirectory = () => useContext(LearnDirectoryContext)

export default LearnDirectoryContext
